import { Feature } from '@/enums/feature';
import { OrganizationRole } from '@/enums/roles';
import type { Mutation } from '@/types/mutation';
import type { Organization } from '@/types/organization';

export type Employee = Mutation & {
    _id: string;
    initials: string;
    firstName: string;
    lastName: string;
    fullName: string;
    email: string;
    staffNumber?: string | null;
    jobTitle?: string | null;
    dateOfBirth?: Date | null;
    currentOrganization?: Organization['_id'];
    password?: string;
    isSuperAdmin?: boolean;
    isSecurityOfficer?: boolean;
    status: EmployeeStatus;
};

export type FullNameEmployee = {
    _id: Employee['_id'];
    fullName: Employee['fullName'];
};

export enum EmployeeStatus {
    Active = 'active',
    Inactive = 'inactive'
}

export type EmployeeForm = {
    _id?: Employee['_id'];
    initials: Employee['initials'];
    firstName: Employee['firstName'];
    lastName: Employee['lastName'];
    fullName: Employee['fullName'];
    email?: Employee['email'];
    dateOfBirth?: Employee['dateOfBirth'];
    staffNumber?: Employee['staffNumber'];
    jobTitle?: Employee['jobTitle'];
    currentOrganization?: Employee['currentOrganization'];
    status?: Employee['status'];
};

export interface OrganizationEmployee extends OrganizationEmployeeProperties {
    employee: string | Employee;
}

export interface OrganizationEmployeeProperties {
    employee: string | Employee;
    roles: OrganizationRole[];
    status: EmployeeStatus;
    isReadOnly?: boolean;
    features?: Feature[];
}
